export enum LanguagesEnum {
  Turkish = 'tr',
  English = 'en',
  Russian = 'ru',
  Azerbaijan = 'az',
  Kazakh = 'kk',
  Kyrgyz = 'ky',
  Uzbek = 'uz',
}

// Alias for compatibility
export const Language = LanguagesEnum;

export enum LanguagesFlagEnum {
  Turkish = '🇹🇷',
  English = '🇬🇧',
  Russian = '🇷🇺',
  Azerbaijan = '🇦🇿',
  Kazakh = '🇰🇿',
  Kyrgyz = '🇰🇬',
  Uzbek = '🇺🇿',
}
